import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  CircularProgressLabel,
  Flex,
  Grid,
  Divider,
  Icon,
  Progress,
  SimpleGrid,
  Spacer,
  Stack,
  StackDivider,
  Stat,
  StatHelpText,
  StatLabel,
  StatNumber,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  CardHeader,
  Card,
  CardBody,
  ButtonGroup,
  CardFooter,
  Center,
  FormControl,
  FormErrorMessage,
  Input,
  Switch,
  Heading,
  Image,
  useColorMode,
  useColorModeValue,
  useToast,
} from '@chakra-ui/react';

import { useLocation, useNavigate } from 'react-router-dom';

import { Player } from '@lottiefiles/react-lottie-player';

import bot from '../assets/img/bot.jpeg';
import money from '../assets/img/money_wallpaper.jpeg';

import { useDispatch, useSelector } from 'react-redux';
import { register } from '../redux/slices/auth';
import { filterStoreProduct, getMyProducts } from '../redux/slices/product';
import { useParams } from 'react-router-dom';
import { BiArrowBack } from 'react-icons/bi';
import { sendMessageWithButton } from '../helpers/telegram';

import ArrowSvg from '../assets/svg/arrow-left.svg';

import BigSuccessSvg from '../assets/svg/big-success.svg';

import { MdClose } from 'react-icons/md';

import axios from 'axios';

import {
  useTonConnectModal,
  useTonWallet,
  useTonConnectUI,
} from '@tonconnect/ui-react';
import TonConnect from '@tonconnect/sdk';
import { getMyCart } from '../redux/slices/cart';
import WhiteArrowSvg from '../assets/svg/white-arrow-left.svg';

import { RiMoonClearFill } from 'react-icons/ri';
import { FiSun } from 'react-icons/fi';
import { toggleDarkMode } from '../redux/slices/settings';

export default function PaymentSuccess() {
  const toast = useToast();

  const { colorMode, toggleColorMode } = useColorMode();

  const text = useColorModeValue('white', 'gray.800');

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { id } = useParams();

  let chatInfo = window.Telegram.WebApp.initDataUnsafe.user;

  React.useEffect(() => {
    setTimeout(() => {
      navigate(`/store/${id}`);
    }, 10000);
  }, []);

  return (
    <>
      <Flex
        flexDirection="column"
        justifyContent={'center'}
        pb={{ base: '90px', md: '20px' }}
        // pt={{ base: '120px', md: '75px' }}
        // px={{ base: '20px', md: '20px' }}
      >
        <Card
          p="10px"
          h={'50px'}
          borderRadius={0}
          //   bgColor={'gray.100'}
          w="100%"
          alignSelf={'center'}
          mb={10}
        >
          <Flex direction={'row'} justifyContent={'space-between'}>
            <Button
              onClick={() => navigate(`/store/${id}`)}
              variant="ghost"
              alignSelf={'flex-start'}
            >
              <Image
                src={colorMode == 'light' ? ArrowSvg : WhiteArrowSvg}
                mr={3}
              />
              <Text fontSize={'16px'}>NOTSTORE</Text>
            </Button>

            <Box
              alignSelf={'center'}
              pr={'10px'}
              onClick={() => {
                dispatch(toggleDarkMode());
                toggleColorMode();
              }}
            >
              {colorMode == 'dark' ? (
                <FiSun />
              ) : (
                <RiMoonClearFill color="black" />
              )}
            </Box>
          </Flex>
        </Card>

        <Center
          mt={'15vh'}
          px={{ base: '20px', md: '20px' }}
          flexDirection={'column'}
        >
          <Image src={BigSuccessSvg} />
          <Text
            fontSize={'20px'}
            lineHeight={'26px'}
            fontWeight={'700'}
            mt={6}
            textAlign={'center'}
          >
            Congratulations
          </Text>

          <Text
            fontSize={'20px'}
            lineHeight={'26px'}
            fontWeight={'700'}
            mt={6}
            textAlign={'center'}
          >
            You’ve earned 10 Not Points
          </Text>

          <Player
            src="https://lottie.host/42115b53-a59c-48ea-9f69-462562883c13/oek1hgrumI.json"
            className="player"
            loop
            autoplay
          />
        </Center>
      </Flex>
    </>
  );
}
